export default __webpack_public_path__ + "static/media/victory.fc1c178d.webp";